/* eslint-disable no-unused-vars */
import Swal from "sweetalert2";
export default {
  namespaced: true,
  state: {
    loading: false,
    data: [],
    pagination: {
      current: null,
      total: null,
      data: [],
    },
  },
  mutations: {
    SET_DATA: (state, data) => {
      state.data = data;
    },
    SET_LOADING: (state, data) => {
      state.loading = data;
    },
    SET_PAGINATION: (state, data) => {
      state.pagination = data;
    },
  },
  actions: {
    getClaims: function ({ commit, state }, payload) {
      const vm = this;
      let url = `ohip/claims`;
      if (payload) {
        if (payload.limit) {
          url = `${url}?limit=${payload.limit}`;
        }
        if (payload.page) {
          url = `${url}${payload.limit ? "&" : "?"}page=${payload.page}`;
        }

        if (payload.clients) {
          url = `${url}${payload.limit || payload.page ? "&" : "?"}clients=${
            payload.clients
          }`;
        }
        if (payload.clinics) {
          url = `${url}${
            payload.limit || payload.page || payload.clients ? "&" : "?"
          }clinics=${payload.clinics}`;
        }
      }

      if (!payload || !payload.page) {
        commit("SET_LOADING", true);
      }
      return new Promise((resolve) => {
        return vm.$http.get(url).then(
          (res) => {
            commit("SET_LOADING", false);
            if (res.status == 200) {
              if (payload && payload.page) {
                commit("SET_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: [...state.pagination.data, ...res.data.data],
                });
              } else if (payload && payload.limit) {
                commit("SET_PAGINATION", {
                  total: res.data.meta.total,
                  current: res.data.meta.current_page,
                  data: res.data.data,
                });
              } else {
                commit("SET_DATA", res.data.data);
              }
              resolve(res.data.data);
            }
          },
          (err) => {
            commit("SET_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
    submitClaims: function (_, payload) {
      const vm = this;
      return new Promise((resolve) => {
        return vm.$http.post("ohip/submit-claims", payload).then(
          (res) => {
            console.log(res);
            if (res.status == 200) {
              Swal.fire({
                title: "Success!",
                text: res.message || "Claims submission in progress",
                icon: "success",
              });
              resolve(res.data);
            }
          },
          (err) => {
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  ((err || {}).data || {}).message || "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
  },
};
